import React from 'react';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { toast } from 'sonner';
import { Gift, Copy } from 'lucide-react';

export function ReferralModal({ open, onOpenChange, referralLink }) {
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(referralLink);
      toast.success('Odkaz zkopírován');
    } catch {
      toast.error('Nepodařilo se zkopírovat odkaz');
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-2">
            <Gift className="w-6 h-6 text-primary" />
          </div>
          <DialogTitle>Chybí ti tvůj oblíbený tvůrce?</DialogTitle>
          <DialogDescription className="text-sm leading-relaxed pt-1">
            Pomoz nám ho přivést na OneSub. Pokud se díky tvému doporučení přidá a začne
            tvořit, získáš <strong className="text-foreground">3 měsíce předplatného zdarma</strong>.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-3 pt-2">
          <p className="text-sm text-muted-foreground">Pošli mu tenhle odkaz:</p>
          <div className="flex gap-2">
            <Input
              readOnly
              value={referralLink}
              onFocus={(e) => e.target.select()}
              className="text-sm"
            />
            <Button onClick={copy} className="bg-primary text-white hover:bg-primary/90 shrink-0">
              <Copy className="w-4 h-4 mr-2" /> Kopírovat
            </Button>
          </div>
          <p className="text-xs text-muted-foreground">
            Tvůrce vyplní krátkou žádanku. Po našem schválení ti automaticky připíšeme 3 měsíce Pro.
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
